module.exports = __webpack_public_path__ + "img/continuar.1437a179.png";